import { render, staticRenderFns } from "./VideoChat.vue?vue&type=template&id=2bd86c9d&scoped=true&"
import script from "./VideoChat.vue?vue&type=script&lang=js&"
export * from "./VideoChat.vue?vue&type=script&lang=js&"
import style0 from "./VideoChat.vue?vue&type=style&index=0&id=2bd86c9d&prod&lang=css&"
import style1 from "./VideoChat.vue?vue&type=style&index=1&id=2bd86c9d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd86c9d",
  null
  
)

export default component.exports